import { differenceInCalendarMonths, parseISO } from 'date-fns'

import type { TSimulacaoCalculoPrazo } from '@/domain/simulador/factories/types/simulacao-calculo'
import { CalculadorPrazoBase } from '@/features/simulador/brasil/domain/calculador-prazo-base'

export class CalculadorPrazoSacocVParcelado extends CalculadorPrazoBase {
  constructor(grupos: TSimulacaoCalculoPrazo) {
    super(grupos)
  }

  override calcular() {
    const { prazoEntregaEmMeses, isEmpreendimentoEntregue } = this.calcularPrazoEntrega()

    const posConclusao = this.grupos.posConclusao

    const dataUltimaEntrada = this.grupos.entradas?.at(-1)?.data
    const dataReferencia = dataUltimaEntrada ?? this.grupos.dataSimulacao

    const prazoSacocVParcelado =
      dataReferencia && posConclusao?.dataFim
        ? differenceInCalendarMonths(parseISO(posConclusao.dataFim), parseISO(dataReferencia))
        : 0

    return {
      prazoPagamentoEmMeses: prazoSacocVParcelado,
      prazoEntregaEmMeses,
      isEmpreendimentoEntregue,
    }
  }
}
